<template>
    <div class="agreement-users">
        <section class="agreement-users__card">
            <div class="agreement-users__card-head">
                <h6 class="mb-0">Add to agreement</h6>
                <span class="text-muted small">Find a user by email, then attach an installation</span>
            </div>

            <div class="row g-2 align-items-center mb-3" style="max-width: 520px;">
                <div class="col">
                    <input
                        class="form-control"
                        type="email"
                        placeholder="user@example.com"
                        v-model="email"
                        @keyup.enter="findUserByEmail"
                    />
                </div>
                <div class="col-auto">
                    <button class="btn btn-primary" type="button" :disabled="!email || finding" @click="findUserByEmail()">
                        {{ finding ? 'Searching…' : 'Find' }}
                    </button>
                </div>
            </div>

            <div v-if="user === ''" class="alert alert-warning py-2 mb-0">No user found for that email.</div>
            <div v-else-if="user && user.email" class="agreement-users__found">
                <div class="agreement-users__found-email">{{ user.email }} <span class="text-muted">#{{ user.userId }}</span></div>
                <div v-if="user.installations">
                    <div v-if="user.installations.length === 0" class="text-muted small mt-2">
                        No suitable installations found for this agreement.
                    </div>
                    <div v-else class="table-responsive mt-2">
                        <table class="table table-sm align-middle mb-0 agreement-users__inst-table">
                            <thead>
                                <tr>
                                    <th>App</th>
                                    <th>Ship / device</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="inst in user.installations" :key="inst.id">
                                    <td>{{ getAppById(inst.appId) }} <span class="text-muted">({{ getPlatformById(inst.platformId) }})</span></td>
                                    <td>{{ inst.shipName || '—' }} <span v-if="inst.deviceCode" class="text-muted">{{ inst.deviceCode }}</span></td>
                                    <td class="text-end">
                                        <button
                                            class="btn btn-sm btn-outline-primary"
                                            type="button"
                                            @click="addUserToAgreement(inst.id)"
                                        >
                                            Add
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>

        <user-list
            :users="users"
            :agreementId="agreementId"
            :agreements="agreements"
            @fetch="getAgreementUsers"
        />
    </div>
</template>

<script>
import myAxios from '@/services/myAxios';
import UserList from './UserList.vue';

export default {
    components: { UserList },
    data() {
        return {
            email: null,
            user: {},
            users: [],
            agreements: [],
            agreementId: this.$route.params.id,
            finding: false
        }
    },
    mounted() {
        this.getAgreementUsers()
        this.fetchAgreements()
    },
    methods: {
        fetchAgreements() {
            myAxios.post("/api/agreement/query", {})
                .then(resp => { this.agreements = resp.data })
        },
        getAgreementUsers() {
            myAxios.get("/api/agreement/agreement-users", { params: { agreementId: this.$route.params.id } })
                .then(resp => { this.users = resp.data })
        },
        findUserByEmail() {
            if (!this.email) return
            this.finding = true
            myAxios.get("/api/agreement/get-user-for-agreement", { params: { email: this.email, agreementId: this.$route.params.id } })
                .then(resp => { this.user = resp.data })
                .finally(() => { this.finding = false })
        },
        addUserToAgreement(installationId) {
            myAxios.post("/api/agreement/add-user-inst", { agreementId: this.$route.params.id, userId: this.user.userId, installationId })
                .then(() => {
                    this.getAgreementUsers()
                    this.findUserByEmail()
                })
        },
        getAppById(id) {
            switch (id) {
                case 0: return "mKart"
                case 1: return "NjordPilot"
                case 2: return "Vega"
                case 10: return "dKart"
                case 11: return "ECDIS"
                case 101: return "mKartEcdis"
                case 102: return "dKartNavigator"
                case 105: return "dKartFishing"
                default: return "n/a"
            }
        },
        getPlatformById(id) {
            switch (id) {
                case 1: return "WinPC"
                case 2: return "WinCE"
                case 3: return "Android"
                case 4: return "iOS"
                default: return "n/a"
            }
        }
    }
}
</script>

<style scoped>
.agreement-users {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.agreement-users__card {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 1.1rem 1.25rem;
}

.agreement-users__card-head {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0.5rem 1rem;
    margin-bottom: 0.85rem;
}

.agreement-users__found {
    border-top: 1px solid #f1f3f5;
    padding-top: 0.85rem;
}

.agreement-users__found-email {
    font-weight: 600;
}

.agreement-users__inst-table {
    margin-bottom: 0;
}

.agreement-users__inst-table thead th {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #6c757d;
    font-weight: 600;
    border-bottom-width: 1px;
}
</style>
